import { useMembershipPlans } from '~/src/common/brooklyn';
import { nr } from '~/src/common/newRelic';
// TODO move useRunOnlyOnce to 'common'
import { useRunOnlyOnce } from '~/src/components/hooks/useRunOnlyOnce';

export const useAnnualSavingsPercentage = () => {
  const { plans, loading } = useMembershipPlans();

  const annualSubscriptionYearlyCost = Number(plans?.annual?.costs?.[0]);
  const monthlySubscriptionYearlyCost = Number(plans?.basic?.costs?.[0]) * 12;
  const reportErrorOnce = useRunOnlyOnce(() => {
    nr.noticeError(
      new Error(
        `Annual saving calculation ERROR. annual cost: ${annualSubscriptionYearlyCost}, motnly cost: ${monthlySubscriptionYearlyCost} `,
      ),
    );
  }, [plans]);

  if (loading) {
    return 0;
  }

  const savings =
    100 - Math.round((annualSubscriptionYearlyCost / monthlySubscriptionYearlyCost) * 100);
  if (isNaN(savings) || savings < 0) {
    reportErrorOnce();
    return 0;
  }

  return savings;
};
